// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\MemoResponse

import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type MemoApiResponse = {
	id: string;
	title: string;
	content: string;
	color: string;
	important: boolean;
	startDate: string | null;
	endDate: string | null;
	createdAt: string;
	updatedAt: string;
	userId: string;
};

export type Memo = {
	id: string;
	title: string;
	content: string;
	color: string;
	important: boolean;
	startDate: DateTime | null;
	endDate: DateTime | null;
	createdAt: DateTime;
	updatedAt: DateTime;
	userId: string;
};

export function hydrateMemo(data: MemoApiResponse): Memo {
	return {
		...data,
		startDate: DateTimefromYmd(data.startDate),
		endDate: DateTimefromYmd(data.endDate),
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
	};
}